import { orgQueryKeys } from '@/config/queryKeys';
import { ORGS_QUERY_GC_TIME, ORGS_QUERY_STALE_TIME } from '@/constants';
import { Org } from '@/types';
import { useQuery } from '@tanstack/react-query';

import { fetchOrganizations } from '../orgUtils';

/**
 * Custom hook to fetch organizations.
 * @param initialData - Optional initial data for hydration.
 * @returns React Query result for organizations.
 */
export function useOrganizations(initialData?: Org[]) {
  const query = useQuery<Org[]>({
    queryKey: orgQueryKeys.list(),
    queryFn: fetchOrganizations,
    initialData,
    staleTime: ORGS_QUERY_STALE_TIME,
    gcTime: ORGS_QUERY_GC_TIME,
    refetchOnWindowFocus: 'always',
    refetchOnMount: 'always',
  });

  return {
    ...query,
  };
}
